import DPTextBox from "framework/components/DPTextBox";
import React from "react";
import { Button, Col, Label, Row } from "reactstrap";
import { Context } from '../../../app-contexts/CommonContexts';
import { useContext } from "react"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic";
import DPSwitch from "framework/components/DPSwitch";


const PasswordResetContent = ({
    formInputs, formInputChange,
    userModelTrigger,
    userModelOpen, menuName, menuCode,
    userGetSelectedRow, validateUserCode, switchOnchange }) => {

    const ApiURL = window.Links.ApiURL
    //import from contexts
    const {
        getMenuDetails, passwordpolicy, passwordPolicyDescription, addtoFavourite, mobileNumberRegexp, emailRegexp, fetchAutoCode, masterAuditLog, getSelectedMasterPermissions
    } = useContext(Context);

    return (
        <>
            <Row>
                <label className="col-sm-10 col-md-12 col-form-label">
                    The password reset feature allows users to securely reset their passwords if they have forgotten them or need to update them for security reasons.
                </label>
            </Row>
            {passwordPolicyDescription ? <Row className="mb-3">

                <label className="col-sm-10 col-md-12 col-form-label">
                    Password Policy: {passwordPolicyDescription}
                </label>
            </Row> : null}
            <Row>
                <Col sm={12} md={6} className="mb-4-sm">
                    <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="User *"
                        textType="text"
                        placeholder="User Code"
                        maxLength="20"
                        name={"usercode"}
                        value={formInputs.usercode}
                        onChange={formInputChange}
                        onBlur={(e) => validateUserCode(e.target.value)}
                    />
                    <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="New Password *"
                        textType="text"
                        placeholder="New Password"
                        maxLength="20"
                        name={"password"}
                        value={formInputs.password}
                        onChange={formInputChange}
                        showHiddenPassword={true}
                    />
                    <DPTextBox
                        rowClass="mb-4-sm"
                        labelText="Confirm Password *"
                        textType="text"
                        placeholder="Confirm Password"
                        maxLength="20"
                        name={"confirmpassword"}
                        value={formInputs.confirmpassword}
                        onChange={formInputChange}
                        showHiddenPassword={true}
                    />
                </Col>
                <Col sm={12} md={6} className="mb-4-sm">
                    <Row>
                        <Col sm={12} md={2} className="mb-4-sm">
                            <Button
                                color="success"
                                className="btn-sm"
                                size='sm'
                                onClick={e => {
                                    userModelTrigger()
                                }}
                                style={{ width: 'auto' }}
                            >
                                <i
                                    className="mdi mdi-search-web"
                                    style={{ fontSize: "12px" }}
                                ></i>
                            </Button>
                        </Col>
                        <Col sm={12} md={10} className="d-flex  mb-4-sm">

                            <Label
                                htmlFor="example-text-input"
                                className={`col-md-5 col-form-label-sm`}
                            >
                                Skip Password Policy Validation
                            </Label>
                            <DPSwitch
                                labelText="Auto Generate"
                                name="skip_validation"
                                onChange={switchOnchange}
                                checked={formInputs.skip_validation}
                                rowClass={"mb-4-sm"}

                            />

                        </Col>
                    </Row>
                </Col>
            </Row>

            <DPSearchBoxDynamic
                columns={[]}
                mainTitle={"User Search"}
                isOpen={userModelOpen}
                toggle={userModelTrigger}
                getSelect={userGetSelectedRow}
                APIURL={ApiURL}
                URLPath={"USER"}
                MenuCode={menuCode}
                KeyVal={"USE"}
                searchBy={"UH_ID"}
                FilterStr={'a'}
            />
        </>
    );
}

export default PasswordResetContent;